module.exports = __webpack_public_path__ + "img/wallet-icon.e82a2778.svg";